import { Logger } from '@/services/Logger';
import { getImpersonatedPartnerId } from '@/contexts/partnerContext';
import { authService } from '@/services/AuthService';
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: `${import.meta.env.VITE_API_BASE}/api`,
});

axiosInstance.interceptors.request.use(
    async (configuration) => {

      Logger.debug(`[API Request] ${configuration.method?.toUpperCase()} ${configuration.url}`);
      if (authService.authenticated) {
        try {
          if (authService.isTokenExpired()) {
            await authService.refreshToken()
          }

          configuration.headers.Authorization = `Bearer ${await authService.getToken()}`;
        } catch (error) {
          console.error('Failed to refresh token', error);
          authService.login();
        }
      }

      const impersonatedPartnerId = getImpersonatedPartnerId(); 
      if (impersonatedPartnerId) {
          configuration.headers['X-Partner-ID'] = impersonatedPartnerId;
      }
      
      return configuration;
    },
    (error) => {
      return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
      Logger.debug(`[API Response] ${response.config.method?.toUpperCase()} ${response.config.url} - Status: ${response.status}`);
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        authService.logout();
      }

      const message = error.response?.data?.message || 'An unexpected error occurred';
      return Promise.reject(new Error(message));
    }
);

export default axiosInstance;